import useSWR from 'swr';
import { fetchEmployerTopJobs, EmployerTopJobsResponse } from '@services/api/employer-top-jobs';


// Constants
// ********************************************
export const EMPLOYER_TOP_JOBS_DEFAULT_LIMIT = 3;
const SWR_KEY = '/v1/my-jobs#home-employer';


/**
 * @description Fetches the company's top N most recent own jobs for the home slot.
 *
 * Pass `enabled = false` (non-company context or unauthenticated) to skip the fetch.
 * No retries — the home slot must never block the page.
 *
 * Returns `MyJobCard` items sliced to `limit` (the backend already caps via `&limit`,
 * the slice is a defensive guard).
 */
export const useEmployerTopJobs = (
  locale: Locale,
  enabled = true,
  limit = EMPLOYER_TOP_JOBS_DEFAULT_LIMIT,
) => {
  const { data, isLoading } = useSWR<EmployerTopJobsResponse>(
    enabled ? [SWR_KEY, locale, limit] : null,
    () => fetchEmployerTopJobs(limit, locale),
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      errorRetryCount: 0,
    },
  );

  const items = (data?.items ?? []).slice(0, limit);

  return {
    items,
    isLoading: enabled && isLoading,
    hasItems: items.length > 0,
  };
};
